<div class="w-100 d-flex mb-5 justify-content-end align-items-center gap-3">
  <button class="btn btn-primary max-content" (click)="exportReport()">
    {{ "collections.export_report" | translate }}
  </button>
</div>
<div class="container-fluid p-0">
  <div class="row">
    <div class="col-sm-12">
      <div class="mt-2">
        <div class="">
          <div class="col-sm-12 col-lg-12 col-xl-12">
            <app-table
              [headers]="headers"
              [columnWidth]="columnWidth"
              [data]="collections"
              [currentPage]="currentPage"
              [totalItems]="totalItems"
              [totalPages]="totalPages"
              [itemsPerPage]="itemsPerPage"
              [loading]="isLoading"
              (onFilterChange)="onFilterChange($event)"
              (handlePageChange)="onPageChange($event)"
              (handleItemsPerPageChange)="onItemsPerPageChange($event)"
              (sortChanged)="onSortChanged($event)"></app-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
